export default __webpack_public_path__ + "static/media/key-click.c91cd68f.mp3";